import { Box, IconButton, useTheme, Typography } from '@mui/material';
import { PlusFillIcon } from 'src/assets';

type AddWidgetButtonProps = {
  onClick: () => void;
};

export const AddWidgetButton = ({ onClick }: AddWidgetButtonProps) => {
  const theme = useTheme();
  const onClickHandler = () => {
    onClick();
  };
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '-25px',
        right: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0px 40px 58px 0',
      }}
    >
      <Typography
        sx={{ fontSize: '14px', fontWeight: theme.typography.fontWeightBold, color: '#919EAB' }}
      >
        Add widget
      </Typography>
      <IconButton
        data-sm="add-widget-button"
        sx={{
          width: '56px',
          height: '56px',
          background: theme.palette.primary.main,
          marginLeft: '12px',
          '&:hover': {
            boxShadow: ' 0 8px 16px 0 rgba(5, 182, 178, 0.24)',
            backgroundColor: theme.palette.primary.dark,
          },
        }}
        onClick={onClickHandler}
      >
        <PlusFillIcon fill={theme.palette.common.white} width={16} height={16} />
      </IconButton>
    </Box>
  );
};
